// extracted by mini-css-extract-plugin
export default {"cancelLink":"gW-z"};